import React from "react";
import About from "../components/About";
import Clinets from "../components/Clients";
import Footer from "../components/Footer";
import Header from "../components/Header";
import National from "../components/National";
import Nav from "../components/Nav";
import Services from "../components/Services";
import Studies from "../components/Studies";
import Sub from "../components/Sub";
import Testimonials from "../components/Testimonials";
import Layout from "./Layout";

const Home = () => {
  return (
    <>
      <Layout>
        <Nav />
        <Header />
        <About />
        <Testimonials />
        <Services />
        <National />
        <Clinets />
        <Studies />
        <Sub />
        <Footer />
      </Layout>
    </>
  );
};

export default Home;
